import { runtime } from '../runtime';
import { openExternal as openSystemLink } from './web';

export async function callPhone(number) {
    if (!runtime.isNative()) throw new Error('Calling requires a native app');
    const value = String(number ?? '').trim();
    // Accept one ordinary phone number, never extensions, dialing commands or URLs.
    if (!/^\+?[\d\s().-]+$/.test(value)) throw new Error('Device phone number unavailable');
    const normalized = value.replace(/[\s().-]/g, '');
    if (!/^\+?[1-9]\d{6,14}$/.test(normalized)) throw new Error('Device phone number unavailable');
    // Capacitor hands tel: navigation to the OS instead of replacing the WebView.
    return openSystemLink(`tel:${normalized}`);
}
